import {getIsMobileApp} from 'src/lib/get-is-mobile-app';

export function attachCheckoutButtonParams(baseUrl: string) {
    const searchParams = new URLSearchParams();

    if (getIsMobileApp()) {
        searchParams.set('display_type', 'mobile_app');
    }

    if (Array.from(searchParams).length === 0) {
        return baseUrl;
    }
    return `${baseUrl}?${searchParams.toString()}`;
}
